import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import QrCodeWithLogo from 'qrcode-with-logos';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var ViewQrCodeModalComponent = /** @class */ (function () {
    function ViewQrCodeModalComponent(data, translationLoaderService) {
        this.data = data;
        this.translationLoaderService = translationLoaderService;
        this.translationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    ViewQrCodeModalComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.qrCodeWithLogo = new QrCodeWithLogo({
                            content: this.data.qrCode,
                            width: 265,
                            nodeQrCodeOptions: {
                                margin: 0,
                                errorCorrectionLevel: 'H'
                            },
                            image: document.getElementById('qr-code-img'),
                            logo: {
                                src: '/assets/images/logos/f_logo_azul.png'
                            }
                        });
                        return [4 /*yield*/, this.qrCodeWithLogo.toImage()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewQrCodeModalComponent.prototype.downloadQrCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.qrCodeWithLogo.downloadImage((this.data.fileName || 'qr-code') + "-" + this.data.qrCode + ".png");
                return [2 /*return*/];
            });
        });
    };
    return ViewQrCodeModalComponent;
}());
export { ViewQrCodeModalComponent };
